import { useIntl } from 'react-intl';

import useSessionStatusMap from 'hooks/useSessionStatusMap';

import Table from 'components/Table';
import { TableColumn } from 'components/Table/types';

interface SessionsTableProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[];
}
const SessionsTable: React.FC<SessionsTableProps> = ({ data }) => {
  const intl = useIntl();
  const sessionStatusMap = useSessionStatusMap();

  const SessionsColumns: TableColumn[] = [
    {
      dataKey: 'session',
      key: 'session',
      title: intl.formatMessage({ id: 'ENDUSER.SESSION.LABEL' }),
      render: session =>
        Math.abs(session - 1 - data.length) as unknown as string,
    },
    {
      dataKey: 'start_at',
      key: 'start_at_date',
      title: intl.formatMessage({ id: 'ENDUSER.SESSION.DATE' }),
      render: date => {
        const dateStartAt = new Date(date);
        return new Intl.DateTimeFormat(intl.locale, { dateStyle: 'long' })
          .format(dateStartAt)
          .toString();
      },
    },
    {
      dataKey: 'start_at',
      key: 'start_at_hour',
      title: intl.formatMessage({ id: 'ENDUSER.SESSION.TIME' }),
      render: date => {
        const dateStartAt = new Date(date);
        return new Intl.DateTimeFormat(intl.locale, {
          timeStyle: 'short',
        })
          .format(dateStartAt)
          .toString();
      },
    },
    {
      dataKey: 'status',
      key: 'status',
      title: intl.formatMessage({ id: 'ENDUSER.SESSION.STATUS' }),
      render: (status: string) => {
        return sessionStatusMap(status);
      },
    },
  ];
  return <Table columns={SessionsColumns} data={data} />;
};

export { SessionsTable };
